module.exports = __webpack_public_path__ + "img/other.6cb35b6b.svg";